export const Colors = {
  black: '#1D1B20',
  white: '#FFFFFF',
  darkBlue: '#004A72',
  blue: {
    '100': '#1072BA',
    '60': '#6EA8C9',
    '20': '#CFE3F1',
    '50': '#9CC5E2',
    '5': '#F7FAFE',
    '3': '#F8FBFD',
  },
  skyBlue: {
    '100': '#1A8BC8',
    '20': '#D4EBF7',
    '50': '#8AC7E8',
    '5': '#F3FAFD',
    '3': '#F5FBFE',
  },
  turquoise: {
    '100': '#2ED3AE',
    '50': '#81E3CE',
    '30': '#EAFAFB',
    '20': '#D4F2ED',
    '10': '#EAFAF6',
  },
  gray: {
    '100': '#777679',
    '50': '#BBBABC',
    '20': '#E4E4E4',
    '10': '#F1F1F2',
    '5': '#F5F5F7',
  },
  orange: {
    '100': '#EE8607',
    '10': '#FDF2E6',
  },
  red: {
    '100': '#FF4A4A',
    '50': '#FFB2B2',
    '10': '#FFEDED',
  },
  yellow: {
    '100': '#F9D208',
    '50': '#FCF0B5',
    '20': '#FEFAE6',
    '10': '#FDF3E6',
  },
  green: {
    '100': '#099C44',
    '50': '#78C998',
    '20': '#40B26F',
    '10': '#E6F5EC',
  },
  violet: {
    '100': '#944E9A',
    '50': '#C49EC8',
    '20': '#F4EDF5',
  },
} as const;
